<template>
<main class="content">
	<div class="row">
		<h1>
              Edit blocked timeslot
          </h1>
	</div>
	<form action="" class="form">
		<Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

		<fieldset class="form--item">
			<label class="label" for="">
                  Wall:
              </label>
			<div class="input_text">
				<v-select v-model="wallId" required :searchable="false" placeholder="Click to select a wall" :options="walls"></v-select>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                  From this day:
              </label>
			<div class="input_text">
				<el-date-picker required v-model="starttime.date" type="date" placeholder="From this day:">
				</el-date-picker>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                  From this timeslot:
              </label>
			<div class="input_text">
				<el-time-select v-model="starttime.time" :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '23:45'
                      }" placeholder="Click to select a start timeslot">
				</el-time-select>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                  To this day:
              </label>
			<div class="input_text">
				<el-date-picker required v-model="endtime.date" type="date" placeholder="To this day:">
				</el-date-picker>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                  To this timeslot:
              </label>
			<div class="input_text">
				<el-time-select v-model="endtime.time" :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '23:45'
                      }" placeholder="Click to select a start timeslot">
				</el-time-select>
			</div>
		</fieldset>
		<fieldset class="form--item">
			<label class="label" for="">
                  Reason:
              </label>
			<div class="input_text">
				<input name="" v-model="blocked.reason" placeholder="Add a reason why you block these timeslots" type="text" value="I want to take a nap." />
			</div>
		</fieldset>
		<div class="row">
			<a class="btn btn_green u-fleft u-mr1" @click="updateBlocked()">
                  Update
              </a>
			<a class="btn btn_red u-fleft" @click="confirmToggle()">
                  Delete
              </a>
		</div>
	</form>
	<confirm resource="blocked timeslot" :visible.sync="alertVisible"></confirm>
	<ok resource="blocked timeslot" resource-plural="blocked timeslots" :visible.sync="okVisible"></ok>
	<loading :visible.sync="loadingVisible"></loading>
</main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import * as EditResource from '../../mixins/editResource.mixin';
import * as ValidateForm from '../../mixins/validate-form.mixin';
import vSelect from "vue-select"
import Message from '../Message.vue'
import Loading from '../Loading.vue'

import Confirm from '../Modals/modal_confirm';
import Ok from '../Modals/modal_ok';
var moment = require('moment');

export default {
	name: 'EditBlocked',
	components: {
		Confirm,
		Ok,
		Message,
		vSelect,
		Loading
	},
	mixins: [EditResource],
	data() {
		return {
			model: 'blocked',
			resource: 'schedule/blocked',
			parentResource: 'Blocked',
			alertVisible: false,
			okVisible: false,
			blocked: {
				wallId: ''
			},
			walls: [],
			wallId: '',
			starttime: {
				date: '',
				time: ''
			},
			endtime: {
				date: '',
				time: ''
			}
		}
	},
	created() {
		var self = this;
		HttpService.index('walls', {}, function(response, error) {
			self.walls = response.result.data;
			self.walls = self.walls.map(item => {
				return {
					value: item.id,
					label: item.name
				}
			});
		});
	},
	mounted() {
		this.fetchResource(this.$route.params.id, {});
	},
	methods: {
		updateBlocked() {
			this.blocked.wallId = this.wallId.value || this.blocked.wallId;
			this.blocked.from = this.getTimeslot(this.starttime) || this.blocked.from;
			this.blocked.to = this.getTimeslot(this.endtime) || this.blocked.to;
			this.updateResource(this.$route.params.id, this.blocked);
		},
		getTimeslot(datetime) {
			let time = datetime.time.split(":");
			let slot = time[0] * 4 + time[1] / 15;
			if (isNaN(slot)) {
				time = datetime.time.split("to");
				time = moment(time[0], "hh:mma");
				slot = time.hours() * 4 + time.minutes() / 15
			}
			let datestring = datetime.date;
			datestring = datestring.getFullYear() + '' + ("00" + (datestring.getMonth() + 1)).slice(-2) + ("00" + datestring.getDate()).slice(-2);

			return datestring + ("00" + slot).slice(-2);
		}
	},
	watch: {
		'blocked.fromDate': function(val, change) {
			this.starttime.date = new Date(val);
			this.starttime.time = moment(val).format("hh:mma") + ' to ' + moment(val).add(15, "minutes").format("hh:mma");
		},
		'blocked.toDate': function(val, change) {
			this.endtime.date = new Date(val);
			this.endtime.time = moment(val).format("hh:mma") + ' to ' + moment(val).add(15, "minutes").format("hh:mma");
		},
		'walls': function(val, change) {
			if (this.blocked.wallId)
				this.wallId = this.walls.find(item => item.value == this.blocked.wallId);
		},
		'blocked.wall': function(val, change) {
			this.wallId = this.walls.find(item => item.value == this.blocked.wallId);
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditBlocked.vue?a1f07b7a